import { useCallback, useState } from 'react';
import { IUseModalCommandSuggestions } from '../types';

const useModalCommandSuggestions = ({
  setPrompt,
  onClose,
}: IUseModalCommandSuggestions) => {
  const steps = [
    {
      id: 0,
      title: 'Navegar na Greenfy',
      options: [
        {
          id: 0,
          title: 'IR PARA MEDIDAS',
        },
        {
          id: 1,
          title: 'IR PARA DESEMPENHO',
        },
        {
          id: 2,
          title: 'IR PARA RELATÓRIO DE CONSUMO',
        },
        {
          id: 3,
          title: 'IR PARA DESPESCAS',
        },
        {
          id: 4,
          title: 'IR PARA INÍCIO',
        },
        {
          id: 5,
          title: 'IR PARA MORTALIDADE',
        },
        {
          id: 6,
          title: 'IR PARA ESTOQUE',
        },
      ],
    },
    {
      id: 1,
      title: 'Fazenda',
      options: [
        {
          id: 0,
          title: 'QUANTOS VIVEIROS FÍSICOS EU TENHO?',
        },
        {
          id: 1,
          title: 'QUAL É O VIVEIRO FÍSICO MAIS POPULOSO DA MINHA FAZENDA?',
        },
        {
          id: 2,
          title: 'QUAIS SÃO OS MEUS INSUMOS?',
        },
        {
          id: 3,
          title: 'QUAL O CICLO COM O MAIOR NÚMERO DE VIVEIROS?',
        },
        {
          id: 4,
          title: 'COMO ESTÁ O POVOAMENTO DOS MEUS VIVEIROS?',
        },
        {
          id: 5,
          title: 'FALE SOBRE O CONSUMO DOS MEUS VIVEIROS',
        },
        {
          id: 6,
          title: 'COMO ESTÁ A ANÁLISE DA MINHA ÁGUA',
        },
      ],
    },
    {
      id: 2,
      title: 'ESTOQUE',
      options: [
        {
          id: 0,
          title: 'COMO ESTÁ O MEU ESTOQUE?',
        },
        {
          id: 1,
          title: 'PRECISO COMPRAR ESTOQUE?',
        },
      ],
    },
    {
      id: 3,
      title: 'FINANCEIRO',
      options: [
        {
          id: 0,
          title: 'TÊM PAGAMENTOS PEDENTES?',
        },
        {
          id: 1,
          title: 'TÊM PAGAMENTOS ATRASADOS?',
        },
        {
          id: 2,
          title: 'TENHO RECEBIMENTOS ATRASADOS?',
        },
        {
          id: 3,
          title: 'TOTAL DOS MEUS RECEBIMENTOS ATRASADOS?',
        },
        {
          id: 4,
          title: 'TOTAL DOS MEUS PAGAMENTOS PEDENTES?',
        },
      ],
    },
    {
      id: 4,
      title: 'CONSUMO',
      options: [
        {
          id: 0,
          title: 'INSUMOS MAIS CONSUMIDOS?',
        },
        {
          id: 1,
          title: 'VIVEIRO QUE MAIS CONSOME?',
        },
        {
          id: 2,
          title: 'HORÁRIO COM MAIOR CONSUMO?',
        },
      ],
    },
  ];

  const handelSetPrompt = useCallback(
    (prompt: string) => {
      setPrompt(prompt);
      onClose();
    },
    [setPrompt]
  );

  return { steps, handelSetPrompt };
};

export default useModalCommandSuggestions;
